<template>
  <div>
    <v-container fluid>
      <div class="main">

        <v-row align="center">
          <v-col cols="9">
            <v-tabs background-color="transparent" color="gifty" v-model="tab">
              <v-tab>
                <v-icon left dense>mdi-view-dashboard</v-icon>
                Vue d’ensemble
              </v-tab>

              <v-tab>
                <v-icon left dense>mdi-chart-line</v-icon>
                Consommation
              </v-tab>

              <v-tab>
                <v-icon left dense>mdi-account-group</v-icon>
                Consommateurs
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="3" class="text-end">
            <v-btn color="gifty" depressed dark @click="refresh">
              <v-icon left>mdi-refresh</v-icon>
              Mettre à jour
            </v-btn>
          </v-col>
        </v-row>

        <Widgets ref="widgetsRef" v-if="tab === 0"/>

      </div>
    </v-container>
  </div>
</template>

<script>
import Widgets from "@/views/supplier-dashboard/components/Widgets";

export default {
  components: {Widgets},
  data() {
    return {
      tab: 0,
    }
  },
  methods: {
    refresh() {
      this.$refs.widgetsRef?.getWidgets()
    }
  }
}
</script>

<style scoped>

</style>